import { SortByFn } from "react-table";
import { LinkColumnValue } from "./types";
import { memoize } from "lodash";

const getTime = memoize((date: string) => new Date(date).getTime());

export const isoDateSortType: SortByFn<any> = (rowA, rowB, columnId) => {
  const a = rowA.values[columnId] as string | undefined;
  const b = rowB.values[columnId] as string | undefined;
  if (a === undefined && b === undefined) {
    return 0;
  }
  if (a === undefined) {
    return -1;
  }
  if (b === undefined) {
    return 1;
  }
  return getTime(a) - getTime(b);
};

export const linkSortType: SortByFn<any> = (rowA, rowB, columnId) => {
  const a = rowA.values[columnId] as LinkColumnValue | undefined;
  const b = rowB.values[columnId] as LinkColumnValue | undefined;
  if (a === undefined && b === undefined) {
    return 0;
  }
  if (a === undefined) {
    return -1;
  }
  if (b === undefined) {
    return 1;
  }
  return a.text.localeCompare(b.text);
};
